
// orders/Search.js
import React from "react";

export default function SearchTable({
  aggregators,
  onSearch,
  onAggregatorChange,
}) {
  return (
    <div>
      <select
        id="aggregatorFilter"
        className="search-bar"
        onChange={(e) => onAggregatorChange(e.target.value)}
      >
        <option value="">All Aggregators</option>
        {aggregators.map((agg) => (
          <option key={agg} value={agg}>
            {agg}
          </option>
        ))}
      </select>
      <input
        type="text"
        id="globalSearch"
        placeholder="Search..."
        className="search-bar"
        onChange={(e) => onSearch(e.target.value)}
      />
    </div>
  );
}